export const translations = {
  en: {
    // Header
    header_title: '#1 Online peptide research store {loc}',
    delivery_info: 'Delivery in 3-5 business days with DHL Express 🚚',
    payment_info: 'Secure payment by bank transfer 🏦',
    formula_info: 'Stabilized formula, tolerant to short-term temperature deviations ❄️',
    
    // Navigation
    nav_home: 'Home',
    nav_products: 'Products',
    nav_regimens: 'Peptide Regimens',
    nav_about_peptides: 'What are peptides?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Reconstitution Calculator',
    nav_about: 'About us',
    nav_technology: 'Technology, MSSPT',
    nav_faqs: 'FAQs',
    nav_contact: 'Contact',
    nav_distributor: 'Become our distributor',
    
    // Hero Section
    hero_title: 'First peptide brand that offers pre-mixed and stabilized pens.',
    
    // New Products
    new_products_title: 'New products 🆕',
    new_products_subtitle: 'The latest formulas from PenLab Peptide: highly selective SARMs in pen and other compounds like Ecdysterone and N-Clomiphene. All products are pre-mixed, with high concentration and stabilized in laboratory.',
    
    // Categories
    shop_categories: 'Shop by categories',
    categories_title: 'Shop by Categories',
    
    // Footer
    quality_title: 'Leading supplier of high-quality peptides.',
    quality_subtitle: 'We, the PenLab Peptide team, are dedicated to continuously maintaining and improving the quality of our products and services.',
    footer_company_desc: 'Leading supplier of high-quality peptides for scientific research {loc} and worldwide. Visit penlabpeptide.com',
    footer_quick_links: 'Quick Links',
    footer_information: 'Information',
    footer_follow_us: 'Follow Us',
    footer_stay_updated: 'Stay updated with our latest news and products.',
    footer_copyright: '© {year} PenLab Peptide. All rights reserved.',
    footer_privacy: 'Privacy Policy',
    footer_terms: 'Terms of Service',
    footer_return_policy: 'Return Policy',
    footer_shipping_policy: 'Shipping Policy',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'IMPORTANT NOTICE:',
    footer_disclaimer_text: 'All our products are intended exclusively for scientific research and should not be used for human consumption or medical treatment.',
    
    preferred_products: 'Most preferred products',
    
    highest_quality_title: 'Highest quality peptides {loc}',
    highest_quality_text: 'From production to packaging and delivery, we apply the strictest quality control standards to ensure that all peptides reach you in their purest form. In addition to offering the best value, we also take exceptional care of our customers and offer the fastest delivery times. PenLab Peptide has become the most valued brand and fastest growing peptide supplier for scientific research worldwide.',
    
    blog_title: 'Peptide Blog',
    
    // Common
    view_all: 'View all',
    add_to_cart: 'Add to Cart',
    price_from: 'From',
    regular_price: 'Regular price',
    sale_price: 'Sale price',
    per_unit: 'per unit',
    
    // Disclaimer
    research_disclaimer: 'This product is for research purposes only. Not for human consumption.',
    
    // Quality Section Features
    quality_feature1_title: 'Superior Purity Over 99%',
    quality_feature1_desc: 'All our peptides meet the highest purity standards.',
    quality_feature2_title: 'Stabilized Formula',
    quality_feature2_desc: 'Advanced technology to maintain product efficacy.',
    quality_feature3_title: 'Fast Delivery',
    quality_feature3_desc: 'Shipping in 3-5 business days with DHL Express.',
    substitute_for_intro: 'Frequently sourced as alternative to:',
    substitute_for_note: 'Same mechanism, lab-verified, in stock.',
  },
  es: {
    // Header
    header_title: '#1 Tienda online de péptidos de investigación {loc}',
    delivery_info: 'Entrega en 3-5 días laborables con DHL Express 🚚',
    payment_info: 'Pago seguro por transferencia bancaria 🏦',
    formula_info: 'Fórmula estabilizada, tolerante a desviaciones de temperatura a corto plazo ❄️',
    
    // Navigation
    nav_home: 'Inicio',
    nav_products: 'Productos',
    nav_regimens: 'Regímenes con péptidos',
    nav_about_peptides: '¿Qué son los péptidos?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Calculadora de Reconstitución',
    nav_about: 'Sobre nosotros',
    nav_technology: 'Tecnología, MSSPT',
    nav_faqs: 'FAQs',
    nav_contact: 'Contacto',
    nav_distributor: 'Conviértete en nuestro distribuidor',
    
    // Hero Section
    hero_title: 'Primera marca de péptidos que ofrece plumas premezcladas y estabilizadas.',
    
    // New Products
    new_products_title: 'Nuevos productos 🆕',
    new_products_subtitle: 'Las fórmulas más recientes de PenLab Peptide: SARMs altamente selectivos en bolígrafo y otros compuestos como Ecdysterona y N-Clomifeno. Todos los productos están premezclados, con alta concentración y estabilizados en laboratorio.',
    
    // Categories
    shop_categories: 'Comprar por categorías',
    categories_title: 'Comprar por Categorías',
    
    // Footer
    quality_title: 'Proveedor líder de péptidos de alta calidad.',
    quality_subtitle: 'Nosotros, el equipo de PenLab Peptide, estamos dedicados a mantener y mejorar continuamente la calidad de nuestros productos y servicios.',
    footer_company_desc: 'Proveedor líder de péptidos de alta calidad para investigación científica {loc} y a nivel mundial. Visita penlabpeptide.com',
    footer_quick_links: 'Enlaces Rápidos',
    footer_information: 'Información',
    footer_follow_us: 'Síguenos',
    footer_stay_updated: 'Mantente actualizado con nuestras últimas noticias y productos.',
    footer_copyright: '© {year} PenLab Peptide. Todos los derechos reservados.',
    footer_privacy: 'Política de Privacidad',
    footer_terms: 'Términos de Servicio',
    footer_return_policy: 'Política de Devoluciones',
    footer_shipping_policy: 'Política de Envíos',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'AVISO IMPORTANTE:',
    footer_disclaimer_text: 'Todos nuestros productos están destinados exclusivamente para investigación científica y no deben ser utilizados para consumo humano o tratamiento médico.',
    
    preferred_products: 'Productos más preferidos',
    
    highest_quality_title: 'Péptidos de la más alta calidad {loc}',
    highest_quality_text: 'Desde la producción hasta el empaquetado y la entrega, aplicamos los estándares más estrictos de control de calidad para garantizar que todos los péptidos lleguen a usted en su forma más pura. Además de ofrecer el mejor valor, también cuidamos excepcionalmente de nuestros clientes y ofrecemos los plazos de entrega más rápidos. PenLab Peptide se ha convertido en la marca más valorada y el proveedor de péptidos para investigación científica de más rápido crecimiento a nivel mundial.',
    
    blog_title: 'Blog sobre péptidos',
    
    // Common
    view_all: 'Ver todo',
    add_to_cart: 'Agregar al carrito',
    price_from: 'A partir de',
    regular_price: 'Precio habitual',
    sale_price: 'Precio de oferta',
    per_unit: 'por unidad',
    
    // Disclaimer
    research_disclaimer: 'Este producto es solo para fines de investigación. No para consumo humano.',
    
    // Quality Section Features
    quality_feature1_title: 'Pureza Superior al 99%',
    quality_feature1_desc: 'Todos nuestros péptidos cumplen con los más altos estándares de pureza.',
    quality_feature2_title: 'Fórmula Estabilizada',
    quality_feature2_desc: 'Tecnología avanzada para mantener la eficacia del producto.',
    quality_feature3_title: 'Entrega Rápida',
    quality_feature3_desc: 'Envío en 3-5 días laborables con DHL Express.',
    substitute_for_intro: 'Frecuentemente buscado como alternativa a:',
    substitute_for_note: 'Mismo mecanismo, verificado en laboratorio, en stock.',
  },
  ru: {
    // Header
    header_title: 'Интернет-магазин №1 по продаже исследовательских пептидов {loc}',
    delivery_info: 'Доставка за 3-5 рабочих дней курьером DHL Express 🚚',
    payment_info: 'Безопасная оплата банковским переводом 🏦',
    formula_info: 'Стабилизированная формула, устойчива к кратковременным температурным колебаниям ❄️',
    
    // Navigation
    nav_home: 'Главная',
    nav_products: 'Каталог',
    nav_regimens: 'Схемы применения пептидов',
    nav_about_peptides: 'Что такое пептиды?',
    nav_blog: 'Блог',
    nav_reconstitution_calculator: 'Калькулятор реконституции',
    nav_about: 'О нас',
    nav_technology: 'Технология MSSPT',
    nav_faqs: 'Вопросы и ответы',
    nav_contact: 'Контакты',
    nav_distributor: 'Стать дистрибьютором',
    
    // Hero Section
    hero_title: 'Первый бренд пептидов с готовыми к применению стабилизированными шприц-ручками.',
    
    // New Products
    new_products_title: 'Новинки 🆕',
    new_products_subtitle: 'Новейшие разработки PenLab Peptide: высокоселективные SARM в форме шприц-ручки и другие соединения, экдистерон и N-кломифен. Все продукты готовы к применению, имеют высокую концентрацию и стабилизированы в лабораторных условиях.',
    
    // Categories
    shop_categories: 'Категории товаров',
    categories_title: 'Каталог по категориям',
    
    // Footer
    quality_title: 'Ведущий поставщик высококачественных пептидов.',
    quality_subtitle: 'Команда PenLab Peptide неустанно работает над поддержанием и улучшением качества нашей продукции и сервиса.',
    footer_company_desc: 'Ведущий поставщик высококачественных пептидов для научных исследований {loc} и по всему миру. Наш сайт: penlabpeptide.com',
    footer_quick_links: 'Быстрые ссылки',
    footer_information: 'Информация',
    footer_follow_us: 'Мы в соцсетях',
    footer_stay_updated: 'Подпишитесь, чтобы быть в курсе новостей и новинок.',
    footer_copyright: '© {year} PenLab Peptide. Все права защищены.',
    footer_privacy: 'Политика конфиденциальности',
    footer_terms: 'Условия использования',
    footer_return_policy: 'Политика возврата',
    footer_shipping_policy: 'Политика доставки',
    footer_cookies: 'Файлы cookie',
    footer_disclaimer: 'ВАЖНОЕ УВЕДОМЛЕНИЕ:',
    footer_disclaimer_text: 'Вся наша продукция предназначена исключительно для научных исследований и не подлежит употреблению человеком или применению в медицинских целях.',
    
    preferred_products: 'Популярные товары',
    
    highest_quality_title: 'Пептиды высочайшего качества {loc}',
    highest_quality_text: 'На всех этапах, от производства до упаковки и доставки, мы применяем строжайшие стандарты контроля качества, гарантируя поступление пептидов к вам в максимально чистом виде. Помимо выгодных цен, мы обеспечиваем безупречный сервис и кратчайшие сроки доставки. PenLab Peptide заслужил репутацию самого надёжного бренда и стал самым быстрорастущим поставщиком пептидов для научных исследований по всему миру.',
    
    blog_title: 'Блог о пептидах',
    
    // Common
    view_all: 'Смотреть все',
    add_to_cart: 'В корзину',
    price_from: 'От',
    regular_price: 'Обычная цена',
    sale_price: 'Цена со скидкой',
    per_unit: 'за шт.',
    
    // Disclaimer
    research_disclaimer: 'Только для научных исследований. Не предназначено для употребления человеком.',
    
    // Quality Section Features
    quality_feature1_title: 'Чистота свыше 99%',
    quality_feature1_desc: 'Все наши пептиды соответствуют высочайшим стандартам чистоты.',
    quality_feature2_title: 'Стабилизированная формула',
    quality_feature2_desc: 'Передовые технологии для сохранения эффективности продукта.',
    quality_feature3_title: 'Быстрая доставка',
    quality_feature3_desc: 'Отправка за 3-5 рабочих дней курьером DHL Express.',
    substitute_for_intro: 'Часто запрашивается как альтернатива:',
    substitute_for_note: 'Тот же механизм, лабораторно проверено, в наличии.',
  },

  de: {
    header_title: '#1 Online-Peptid-Forschungsshop {loc}',
    delivery_info: 'Lieferung in 3-5 Werktagen mit DHL Express 🚚',
    payment_info: 'Sichere Zahlung per Banküberweisung 🏦',
    formula_info: 'Stabilisierte Formel, tolerant gegenüber kurzfristigen Temperaturabweichungen ❄️',
    nav_home: 'Startseite',
    nav_products: 'Produkte',
    nav_regimens: 'Peptid-Regime',
    nav_about_peptides: 'Was sind Peptide?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Rekonstitutionsrechner',
    nav_about: 'Über uns',
    nav_technology: 'Technologie, MSSPT',
    nav_faqs: 'FAQs',
    nav_contact: 'Kontakt',
    nav_distributor: 'Werden Sie unser Vertriebspartner',
    hero_title: 'Die erste Peptidmarke, die vorgemischte und stabilisierte Pens anbietet.',
    new_products_title: 'Neue Produkte 🆕',
    new_products_subtitle: 'Die neuesten Formeln von PenLab Peptide: hochselektive SARMs in Pen-Form und andere Verbindungen wie Ecdysterone und N-Clomiphene. Alle Produkte sind vorgemischt, hochkonzentriert und im Labor stabilisiert.',
    shop_categories: 'Nach Kategorien einkaufen',
    categories_title: 'Nach Kategorien einkaufen',
    quality_title: 'Führender Anbieter von hochwertigen Peptiden.',
    quality_subtitle: 'Wir, das PenLab Peptide Team, sind bestrebt, die Qualität unserer Produkte und Dienstleistungen kontinuierlich zu erhalten und zu verbessern.',
    footer_company_desc: 'Führender Anbieter von hochwertigen Peptiden für die wissenschaftliche Forschung {loc} und weltweit. Besuchen Sie penlabpeptide.com',
    footer_quick_links: 'Schnelle Links',
    footer_information: 'Informationen',
    footer_follow_us: 'Folgen Sie uns',
    footer_stay_updated: 'Bleiben Sie auf dem Laufenden über unsere neuesten Nachrichten und Produkte.',
    footer_copyright: '© {year} PenLab Peptide. Alle Rechte vorbehalten.',
    footer_privacy: 'Datenschutzerklärung',
    footer_terms: 'Nutzungsbedingungen',
    footer_return_policy: 'Rückgaberichtlinien',
    footer_shipping_policy: 'Versandrichtlinien',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'WICHTIGER HINWEIS:',
    footer_disclaimer_text: 'Alle unsere Produkte sind ausschließlich für die wissenschaftliche Forschung bestimmt und sollten nicht für den menschlichen Verzehr oder medizinische Behandlungen verwendet werden.',
    preferred_products: 'Beliebteste Produkte',
    highest_quality_title: 'Peptide höchster Qualität {loc}',
    highest_quality_text: 'Von der Produktion über die Verpackung bis zur Lieferung wenden wir strengste Qualitätskontrollstandards an, um sicherzustellen, dass alle Peptide Sie in ihrer reinsten Form erreichen. Neben dem besten Preis-Leistungs-Verhältnis kümmern wir uns auch außergewöhnlich um unsere Kunden und bieten die schnellsten Lieferzeiten. PenLab Peptide hat sich weltweit zur meistgeschätzten Marke und zum am schnellsten wachsenden Peptidanbieter für die wissenschaftliche Forschung entwickelt.',
    blog_title: 'Peptid-Blog',
    view_all: 'Alle ansehen',
    add_to_cart: 'In den Warenkorb',
    price_from: 'Ab',
    regular_price: 'Regulärer Preis',
    sale_price: 'Aktionspreis',
    per_unit: 'pro Einheit',
    research_disclaimer: 'Dieses Produkt ist ausschließlich für Forschungszwecke bestimmt. Nicht für den menschlichen Verzehr.',
    quality_feature1_title: 'Überragende Reinheit über 99%',
    quality_feature1_desc: 'Alle unsere Peptide erfüllen höchste Reinheitsstandards.',
    quality_feature2_title: 'Stabilisierte Formel',
    quality_feature2_desc: 'Fortschrittliche Technologie zur Erhaltung der Produktwirksamkeit.',
    quality_feature3_title: 'Schnelle Lieferung',
    quality_feature3_desc: 'Versand in 3-5 Werktagen mit DHL Express.',
    substitute_for_intro: 'Häufig als Alternative zu:',
    substitute_for_note: 'Gleicher Mechanismus, laborverifiziert, auf Lager.',
  },

  fr: {
    header_title: '#1 Boutique en ligne de peptides de recherche {loc}',
    delivery_info: 'Livraison en 3 à 5 jours ouvrables avec DHL Express 🚚',
    payment_info: 'Paiement sécurisé par virement bancaire 🏦',
    formula_info: 'Formule stabilisée, tolérante aux écarts de température de courte durée ❄️',
    nav_home: 'Accueil',
    nav_products: 'Produits',
    nav_regimens: 'Protocoles de Peptides',
    nav_about_peptides: 'Que sont les peptides ?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Calculatrice de Reconstitution',
    nav_about: 'À propos de nous',
    nav_technology: 'Technologie, MSSPT',
    nav_faqs: 'FAQ',
    nav_contact: 'Contact',
    nav_distributor: 'Devenez notre distributeur',
    hero_title: 'Première marque de peptides à proposer des stylos pré-mélangés et stabilisés.',
    new_products_title: 'Nouveaux produits 🆕',
    new_products_subtitle: 'Les dernières formules de PenLab Peptide : des SARMs hautement sélectifs en stylo et d\'autres composés comme l\'Ecdystérone et le N-Clomiphene. Tous les produits sont pré-mélangés, à haute concentration et stabilisés en laboratoire.',
    shop_categories: 'Acheter par catégories',
    categories_title: 'Acheter par Catégories',
    quality_title: 'Fournisseur leader de peptides de haute qualité.',
    quality_subtitle: 'Nous, l\'équipe PenLab Peptide, nous engageons à maintenir et améliorer continuellement la qualité de nos produits et services.',
    footer_company_desc: 'Fournisseur leader de peptides de haute qualité pour la recherche scientifique {loc} et dans le monde entier. Visitez penlabpeptide.com',
    footer_quick_links: 'Liens rapides',
    footer_information: 'Informations',
    footer_follow_us: 'Suivez-nous',
    footer_stay_updated: 'Restez informé de nos dernières actualités et produits.',
    footer_copyright: '© {year} PenLab Peptide. Tous droits réservés.',
    footer_privacy: 'Politique de confidentialité',
    footer_terms: 'Conditions d\'utilisation',
    footer_return_policy: 'Politique de retour',
    footer_shipping_policy: 'Politique d\'expédition',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'AVIS IMPORTANT :',
    footer_disclaimer_text: 'Tous nos produits sont destinés exclusivement à la recherche scientifique et ne doivent pas être utilisés pour la consommation humaine ou un traitement médical.',
    preferred_products: 'Produits les plus appréciés',
    highest_quality_title: 'Peptides de la plus haute qualité {loc}',
    highest_quality_text: 'De la production à l\'emballage et à la livraison, nous appliquons les normes de contrôle qualité les plus strictes pour garantir que tous les peptides vous parviennent dans leur forme la plus pure. En plus d\'offrir le meilleur rapport qualité-prix, nous prenons également un soin exceptionnel de nos clients et offrons les délais de livraison les plus rapides. PenLab Peptide est devenue la marque la plus appréciée et le fournisseur de peptides à la croissance la plus rapide pour la recherche scientifique dans le monde entier.',
    blog_title: 'Blog sur les peptides',
    view_all: 'Voir tout',
    add_to_cart: 'Ajouter au panier',
    price_from: 'À partir de',
    regular_price: 'Prix normal',
    sale_price: 'Prix soldé',
    per_unit: 'par unité',
    research_disclaimer: 'Ce produit est destiné uniquement à des fins de recherche. Non destiné à la consommation humaine.',
    quality_feature1_title: 'Pureté supérieure à 99 %',
    quality_feature1_desc: 'Tous nos peptides répondent aux normes de pureté les plus élevées.',
    quality_feature2_title: 'Formule stabilisée',
    quality_feature2_desc: 'Technologie avancée pour maintenir l\'efficacité du produit.',
    quality_feature3_title: 'Livraison rapide',
    quality_feature3_desc: 'Expédition en 3 à 5 jours ouvrables avec DHL Express.',
    substitute_for_intro: 'Fréquemment recherché comme alternative à :',
    substitute_for_note: 'Même mécanisme, vérifié en laboratoire, en stock.',
  },

  it: {
    header_title: '#1 Negozio online di peptidi per la ricerca {loc}',
    delivery_info: 'Consegna in 3-5 giorni lavorativi con DHL Express 🚚',
    payment_info: 'Pagamento sicuro tramite bonifico bancario 🏦',
    formula_info: 'Formula stabilizzata, tollerante a brevi deviazioni di temperatura ❄️',
    nav_home: 'Home',
    nav_products: 'Prodotti',
    nav_regimens: 'Regimi di Peptidi',
    nav_about_peptides: 'Cosa sono i peptidi?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Calcolatrice di Ricostituzione',
    nav_about: 'Chi siamo',
    nav_technology: 'Tecnologia, MSSPT',
    nav_faqs: 'Domande Frequenti',
    nav_contact: 'Contatti',
    nav_distributor: 'Diventa nostro distributore',
    hero_title: 'Il primo marchio di peptidi a offrire penne pre-miscelate e stabilizzate.',
    new_products_title: 'Nuovi prodotti 🆕',
    new_products_subtitle: 'Le ultime formule di PenLab Peptide: SARM altamente selettivi in penna e altri composti come Ecdysterone e N-Clomiphene. Tutti i prodotti sono pre-miscelati, ad alta concentrazione e stabilizzati in laboratorio.',
    shop_categories: 'Acquista per categorie',
    categories_title: 'Acquista per Categorie',
    quality_title: 'Fornitore leader di peptidi di alta qualità.',
    quality_subtitle: 'Noi, il team di PenLab Peptide, ci dedichiamo a mantenere e migliorare continuamente la qualità dei nostri prodotti e servizi.',
    footer_company_desc: 'Fornitore leader di peptidi di alta qualità per la ricerca scientifica {loc} e in tutto il mondo. Visita penlabpeptide.com',
    footer_quick_links: 'Link Rapidi',
    footer_information: 'Informazioni',
    footer_follow_us: 'Seguici',
    footer_stay_updated: 'Rimani aggiornato sulle nostre ultime novità e prodotti.',
    footer_copyright: '© {year} PenLab Peptide. Tutti i diritti riservati.',
    footer_privacy: 'Informativa sulla Privacy',
    footer_terms: 'Termini di Servizio',
    footer_return_policy: 'Politica di Reso',
    footer_shipping_policy: 'Politica di Spedizione',
    footer_cookies: 'Cookie',
    footer_disclaimer: 'AVVISO IMPORTANTE:',
    footer_disclaimer_text: 'Tutti i nostri prodotti sono destinati esclusivamente alla ricerca scientifica e non devono essere utilizzati per il consumo umano o per trattamenti medici.',
    preferred_products: 'Prodotti più popolari',
    highest_quality_title: 'Peptidi di altissima qualità {loc}',
    highest_quality_text: 'Dalla produzione all\'imballaggio e alla consegna, applichiamo i più severi standard di controllo qualità per garantire che tutti i peptidi ti arrivino nella loro forma più pura. Oltre a offrire il miglior rapporto qualità-prezzo, ci prendiamo anche cura eccezionale dei nostri clienti e offriamo i tempi di consegna più rapidi. PenLab Peptide è diventato il marchio più apprezzato e il fornitore di peptidi in più rapida crescita per la ricerca scientifica in tutto il mondo.',
    blog_title: 'Blog sui peptidi',
    view_all: 'Visualizza tutto',
    add_to_cart: 'Aggiungi al carrello',
    price_from: 'A partire da',
    regular_price: 'Prezzo regolare',
    sale_price: 'Prezzo in offerta',
    per_unit: 'per unità',
    research_disclaimer: 'Questo prodotto è destinato esclusivamente a scopi di ricerca. Non per consumo umano.',
    quality_feature1_title: 'Purezza Superiore Oltre il 99%',
    quality_feature1_desc: 'Tutti i nostri peptidi soddisfano i più elevati standard di purezza.',
    quality_feature2_title: 'Formula Stabilizzata',
    quality_feature2_desc: 'Tecnologia avanzata per mantenere l\'efficacia del prodotto.',
    quality_feature3_title: 'Consegna Veloce',
    quality_feature3_desc: 'Spedizione in 3-5 giorni lavorativi con DHL Express.',
    substitute_for_intro: 'Spesso scelto come alternativa a:',
    substitute_for_note: 'Stesso meccanismo, verificato in laboratorio, disponibile.',
  },

  pl: {
    header_title: '#1 Sklep internetowy z peptydami do badań {loc}',
    delivery_info: 'Dostawa w 3-5 dni roboczych z DHL Express 🚚',
    payment_info: 'Bezpieczna płatność przelewem bankowym 🏦',
    formula_info: 'Stabilizowana formuła, odporna na krótkotrwałe wahania temperatury ❄️',
    nav_home: 'Strona główna',
    nav_products: 'Produkty',
    nav_regimens: 'Schematy peptydowe',
    nav_about_peptides: 'Czym są peptydy?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Kalkulator Rekonstytucji',
    nav_about: 'O nas',
    nav_technology: 'Technologia, MSSPT',
    nav_faqs: 'FAQ',
    nav_contact: 'Kontakt',
    nav_distributor: 'Zostań naszym dystrybutorem',
    hero_title: 'Pierwsza marka peptydów oferująca gotowe, stabilizowane peny.',
    new_products_title: 'Nowe produkty 🆕',
    new_products_subtitle: 'Najnowsze formuły od PenLab Peptide: wysoce selektywne SARMs w penie oraz inne związki, takie jak Ecdysterone i N-Clomiphene. Wszystkie produkty są gotowe do użycia, o wysokim stężeniu i stabilizowane laboratoryjnie.',
    shop_categories: 'Kupuj według kategorii',
    categories_title: 'Kupuj według kategorii',
    quality_title: 'Wiodący dostawca wysokiej jakości peptydów.',
    quality_subtitle: 'My, zespół PenLab Peptide, jesteśmy zaangażowani w ciągłe utrzymywanie i poprawę jakości naszych produktów i usług.',
    footer_company_desc: 'Wiodący dostawca wysokiej jakości peptydów do badań naukowych {loc} i na całym świecie. Odwiedź penlabpeptide.com',
    footer_quick_links: 'Szybkie linki',
    footer_information: 'Informacje',
    footer_follow_us: 'Obserwuj nas',
    footer_stay_updated: 'Bądź na bieżąco z naszymi najnowszymi wiadomościami i produktami.',
    footer_copyright: '© {year} PenLab Peptide. Wszelkie prawa zastrzeżone.',
    footer_privacy: 'Polityka prywatności',
    footer_terms: 'Regulamin',
    footer_return_policy: 'Polityka zwrotów',
    footer_shipping_policy: 'Polityka wysyłki',
    footer_cookies: 'Pliki cookie',
    footer_disclaimer: 'WAŻNA INFORMACJA:',
    footer_disclaimer_text: 'Wszystkie nasze produkty przeznaczone są wyłącznie do badań naukowych i nie powinny być używane do spożycia przez ludzi ani do leczenia medycznego.',
    preferred_products: 'Najczęściej wybierane produkty',
    highest_quality_title: 'Peptydy najwyższej jakości {loc}',
    highest_quality_text: 'Od produkcji po pakowanie i dostawę stosujemy najsurowsze standardy kontroli jakości, aby zapewnić, że wszystkie peptydy dotrą do Ciebie w najczystszej postaci. Oprócz oferowania najlepszej wartości, dbamy również wyjątkowo o naszych klientów i zapewniamy najszybsze terminy dostaw. PenLab Peptide stał się najbardziej cenioną marką i najszybciej rozwijającym się dostawcą peptydów do badań naukowych na całym świecie.',
    blog_title: 'Blog o peptydach',
    view_all: 'Zobacz wszystkie',
    add_to_cart: 'Dodaj do koszyka',
    price_from: 'Od',
    regular_price: 'Cena regularna',
    sale_price: 'Cena promocyjna',
    per_unit: 'za jednostkę',
    research_disclaimer: 'Ten produkt jest przeznaczony wyłącznie do celów badawczych. Nie do spożycia przez ludzi.',
    quality_feature1_title: 'Doskonała czystość powyżej 99%',
    quality_feature1_desc: 'Wszystkie nasze peptydy spełniają najwyższe standardy czystości.',
    quality_feature2_title: 'Stabilizowana formuła',
    quality_feature2_desc: 'Zaawansowana technologia zapewniająca utrzymanie skuteczności produktu.',
    quality_feature3_title: 'Szybka dostawa',
    quality_feature3_desc: 'Wysyłka w 3-5 dni roboczych z DHL Express.',
    substitute_for_intro: 'Często wybierane jako alternatywa dla:',
    substitute_for_note: 'Ten sam mechanizm, zweryfikowane laboratoryjnie, w magazynie.',
  },

  nl: {
    header_title: '#1 Online peptide onderzoekswinkel {loc}',
    delivery_info: 'Levering in 3-5 werkdagen met DHL Express 🚚',
    payment_info: 'Veilig betalen via bankoverschrijving 🏦',
    formula_info: 'Gestabiliseerde formule, bestand tegen kortstondige temperatuurafwijkingen ❄️',
    nav_home: 'Home',
    nav_products: 'Producten',
    nav_regimens: 'Peptide Regimes',
    nav_about_peptides: 'Wat zijn peptiden?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Reconstitutiecalculator',
    nav_about: 'Over ons',
    nav_technology: 'Technologie, MSSPT',
    nav_faqs: 'Veelgestelde vragen',
    nav_contact: 'Contact',
    nav_distributor: 'Word onze distributeur',
    hero_title: 'Het eerste peptidemerk dat voorgemixte en gestabiliseerde pennen aanbiedt.',
    new_products_title: 'Nieuwe producten 🆕',
    new_products_subtitle: 'De nieuwste formules van PenLab Peptide: zeer selectieve SARMs in pen en andere verbindingen zoals Ecdysterone en N-Clomiphene. Alle producten zijn voorgemengd, met een hoge concentratie en gestabiliseerd in het laboratorium.',
    shop_categories: 'Winkel per categorie',
    categories_title: 'Winkel per Categorieën',
    quality_title: 'Toonaangevende leverancier van hoogwaardige peptiden.',
    quality_subtitle: 'Wij, het PenLab Peptide team, zijn toegewijd aan het continu handhaven en verbeteren van de kwaliteit van onze producten en diensten.',
    footer_company_desc: 'Toonaangevende leverancier van hoogwaardige peptiden voor wetenschappelijk onderzoek {loc} en wereldwijd. Bezoek penlabpeptide.com',
    footer_quick_links: 'Snelle Links',
    footer_information: 'Informatie',
    footer_follow_us: 'Volg ons',
    footer_stay_updated: 'Blijf op de hoogte van ons laatste nieuws en onze producten.',
    footer_copyright: '© {year} PenLab Peptide. Alle rechten voorbehouden.',
    footer_privacy: 'Privacybeleid',
    footer_terms: 'Servicevoorwaarden',
    footer_return_policy: 'Retourbeleid',
    footer_shipping_policy: 'Verzendbeleid',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'BELANGRIJKE MEDEDELING:',
    footer_disclaimer_text: 'Al onze producten zijn uitsluitend bedoeld voor wetenschappelijk onderzoek en mogen niet worden gebruikt voor menselijke consumptie of medische behandeling.',
    preferred_products: 'Meest gewilde producten',
    highest_quality_title: 'Peptiden van de hoogste kwaliteit {loc}',
    highest_quality_text: 'Van productie tot verpakking en levering, wij hanteren de strengste kwaliteitscontrolenormen om ervoor te zorgen dat alle peptiden u in hun puurste vorm bereiken. Naast het bieden van de beste waarde, zorgen we ook uitzonderlijk goed voor onze klanten en bieden we de snelste levertijden. PenLab Peptide is wereldwijd het meest gewaardeerde merk en de snelst groeiende leverancier van peptiden voor wetenschappelijk onderzoek geworden.',
    blog_title: 'Peptide Blog',
    view_all: 'Bekijk alles',
    add_to_cart: 'Toevoegen aan winkelwagen',
    price_from: 'Vanaf',
    regular_price: 'Normale prijs',
    sale_price: 'Aanbiedingsprijs',
    per_unit: 'per eenheid',
    research_disclaimer: 'Dit product is uitsluitend bedoeld voor onderzoeksdoeleinden. Niet voor menselijke consumptie.',
    quality_feature1_title: 'Superieure zuiverheid van meer dan 99%',
    quality_feature1_desc: 'Al onze peptiden voldoen aan de hoogste zuiverheidsnormen.',
    quality_feature2_title: 'Gestabiliseerde formule',
    quality_feature2_desc: 'Geavanceerde technologie om de productwerkzaamheid te behouden.',
    quality_feature3_title: 'Snelle levering',
    quality_feature3_desc: 'Verzending in 3-5 werkdagen met DHL Express.',
    substitute_for_intro: 'Vaak gekozen als alternatief voor:',
    substitute_for_note: 'Zelfde mechanisme, lab-geverifieerd, op voorraad.',
  },

  pt: {
    header_title: '#1 Loja online de pesquisa de peptídeos {loc}',
    delivery_info: 'Entrega em 3-5 dias úteis com DHL Express 🚚',
    payment_info: 'Pagamento seguro por transferência bancária 🏦',
    formula_info: 'Fórmula estabilizada, tolerante a desvios de temperatura de curto prazo ❄️',
    nav_home: 'Início',
    nav_products: 'Produtos',
    nav_regimens: 'Regimes de Peptídeos',
    nav_about_peptides: 'O que são peptídeos?',
    nav_blog: 'Blog',
    nav_reconstitution_calculator: 'Calculadora de Reconstituição',
    nav_about: 'Sobre nós',
    nav_technology: 'Tecnologia, MSSPT',
    nav_faqs: 'FAQs',
    nav_contact: 'Contato',
    nav_distributor: 'Seja nosso distribuidor',
    hero_title: 'Primeira marca de peptídeos a oferecer canetas pré-misturadas e estabilizadas.',
    new_products_title: 'Novos produtos 🆕',
    new_products_subtitle: 'As últimas fórmulas da PenLab Peptide: SARMs altamente seletivos em caneta e outros compostos como Ecdysterone e N-Clomiphene. Todos os produtos são pré-misturados, com alta concentração e estabilizados em laboratório.',
    shop_categories: 'Compre por categorias',
    categories_title: 'Compre por Categorias',
    quality_title: 'Fornecedor líder de peptídeos de alta qualidade.',
    quality_subtitle: 'Nós, a equipe PenLab Peptide, dedicamo-nos a manter e aprimorar continuamente a qualidade dos nossos produtos e serviços.',
    footer_company_desc: 'Fornecedor líder de peptídeos de alta qualidade para pesquisa científica {loc} e em todo o mundo. Visite penlabpeptide.com',
    footer_quick_links: 'Links Rápidos',
    footer_information: 'Informações',
    footer_follow_us: 'Siga-nos',
    footer_stay_updated: 'Mantenha-se atualizado com nossas últimas notícias e produtos.',
    footer_copyright: '© {year} PenLab Peptide. Todos os direitos reservados.',
    footer_privacy: 'Política de Privacidade',
    footer_terms: 'Termos de Serviço',
    footer_return_policy: 'Política de Devolução',
    footer_shipping_policy: 'Política de Envio',
    footer_cookies: 'Cookies',
    footer_disclaimer: 'AVISO IMPORTANTE:',
    footer_disclaimer_text: 'Todos os nossos produtos destinam-se exclusivamente à pesquisa científica e não devem ser usados para consumo humano ou tratamento médico.',
    preferred_products: 'Produtos mais procurados',
    highest_quality_title: 'Peptídeos da mais alta qualidade {loc}',
    highest_quality_text: 'Da produção à embalagem e entrega, aplicamos os mais rigorosos padrões de controle de qualidade para garantir que todos os peptídeos cheguem até você em sua forma mais pura. Além de oferecer o melhor valor, também cuidamos excepcionalmente dos nossos clientes e oferecemos os prazos de entrega mais rápidos. PenLab Peptide tornou-se a marca mais valorizada e o fornecedor de peptídeos que mais cresce para pesquisa científica em todo o mundo.',
    blog_title: 'Blog de Peptídeos',
    view_all: 'Ver tudo',
    add_to_cart: 'Adicionar ao carrinho',
    price_from: 'A partir de',
    regular_price: 'Preço normal',
    sale_price: 'Preço promocional',
    per_unit: 'por unidade',
    research_disclaimer: 'Este produto é apenas para fins de pesquisa. Não para consumo humano.',
    quality_feature1_title: 'Pureza Superior Acima de 99%',
    quality_feature1_desc: 'Todos os nossos peptídeos atendem aos mais altos padrões de pureza.',
    quality_feature2_title: 'Fórmula Estabilizada',
    quality_feature2_desc: 'Tecnologia avançada para manter a eficácia do produto.',
    quality_feature3_title: 'Entrega Rápida',
    quality_feature3_desc: 'Envio em 3-5 dias úteis com DHL Express.',
    substitute_for_intro: 'Frequentemente buscado como alternativa para:',
    substitute_for_note: 'Mesmo mecanismo, verificado em laboratório, em estoque.',
  }
};

// Merge extra UI keys (added in iteration 28 to close the 100% translation
// audit). Kept in a sister file to keep this file scannable.
import { mergeExtraTranslations } from './translations_extra';
mergeExtraTranslations(translations);
